import PropTypes from "prop-types";

function AccordionPanel({ children, isStatic, isActive, id, headlineLeft, headlineRight }) {
  if (isStatic) {
    return (
      <div
        className="accordion accordion-flush accordion-panel accordion-panel-disabled"
        id={`accordion-panel-${id}`}
      >
        <div className="accordion-item">
          <h2 className="accordion-header" id={`accordion-panel-headline-${id}`}>
            <div className="accordion-button-wrapper">
              <button className="accordion-button" type="button">
                <div className="accordion-button-content">
                  <div className="accordion-button-content-left">{headlineLeft}</div>

                  <div className="accordion-button-content-right">{headlineRight}</div>
                </div>
              </button>
            </div>
          </h2>
          <div className="accordion-collapse collapse show">
            <div className="accordion-body">{children}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="accordion accordion-flush accordion-panel" id={`accordion-panel-${id}`}>
      <div className="accordion-item">
        <h2 className="accordion-header" id={`accordion-panel-headline-${id}`}>
          <div className="accordion-button-wrapper">
            <button
              className={isActive ? "accordion-button" : "accordion-button collapsed"}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#accordion-panel-collapse-${id}`}
              aria-expanded={isActive ? "true" : "false"}
              aria-controls={`accordion-panel-collapse-${id}`}
            >
              <div className="accordion-button-content">
                <div className="accordion-button-content-left">{headlineLeft}</div>

                <div className="accordion-button-content-right">{headlineRight}</div>
              </div>
            </button>
          </div>
        </h2>
        <div
          id={`accordion-panel-collapse-${id}`}
          className={
            isActive ? "accordion-collapse collapse show" : "accordion-collapse collapsed collapse"
          }
          aria-labelledby={`accordion-panel-headline-${id}`}
          data-bs-parent={`#accordion-panel-${id}`}
        >
          <div className="accordion-body">{children}</div>
        </div>
      </div>
    </div>
  );
}

AccordionPanel.propTypes = {
  children: PropTypes.node.isRequired,
  isStatic: PropTypes.bool,
  isActive: PropTypes.bool,
  id: PropTypes.number,
  headlineLeft: PropTypes.node,
  headlineRight: PropTypes.node,
};

export default AccordionPanel;
